import { render, staticRenderFns } from "./GcType.vue?vue&type=template&id=3433dbef&scoped=true&"
import script from "./GcType.vue?vue&type=script&lang=js&"
export * from "./GcType.vue?vue&type=script&lang=js&"
import style0 from "./GcType.vue?vue&type=style&index=0&id=3433dbef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3433dbef",
  null
  
)

export default component.exports